module.exports = __webpack_public_path__ + "img/cloud-maple-left.bd805b8.webp";